module.exports = __webpack_public_path__ + "img/case3.f0dd6ff5.jpg";